var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasinoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6965 7.13712C12.3369 2.84856 6.94206 0 6.94206 0C6.94206 0 1.6634 2.84853 0.303477 7.13712C-0.390717 9.70017 0.238942 11.2637 0.865112 12.1068C1.6173 13.12 2.84784 13.7249 4.15622 13.7249C4.79089 13.7249 5.40038 13.521 5.93587 13.2036L5.62127 15.4555C5.60208 15.5922 5.64198 15.7306 5.73072 15.8354C5.81935 15.9402 5.94787 16 6.08305 16H8.03352C8.16858 16 8.29667 15.9402 8.3854 15.8358C8.47359 15.731 8.51349 15.5922 8.49485 15.4559L8.1954 13.3135C8.71267 13.5674 9.28379 13.7253 9.84389 13.7253C11.1526 13.7253 12.3827 13.1204 13.135 12.1073C13.7611 11.2635 14.3907 9.70013 13.6965 7.137L13.6965 7.13712Z",
    fill: "#F00F38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasinoIcon);
export default __webpack_public_path__ + "static/media/casino-icon.72317d2276c431d6b10e7cfcca487dc1.svg";
export { ForwardRef as ReactComponent };